import React, {   Component,
  useState,
  createContext,
  useEffect,
  useRef, useCallback} from "react";
import { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { useRouter } from "next/router";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import HsnPopup from "./hsn_dialog";
import { Dialog, Transition } from "@headlessui/react";
import Categorymenu from "@/layout/hsn_categorymenu";
import axios from "axios";
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";
import { LineWave } from "react-loader-spinner";
import classNames from "classnames";
import { Collapse } from "react-collapse";
import { pushCleverTapEvent } from "../pushCleverTapEvent";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

export default function HsnFinder({ onDataTransfer}) {
  const [show3cradSection, setcrad3Section] = useState(true);
  const [showSeeAllSection, setSeeAllSection] = useState(false);
  const [showFAQSection, setFAQSection] = useState(true);
  const [showCounterSection, setCounterSection] = useState(true);
  const [removePadClass, setremovePadClass] = useState(true);
  const [addPadClass, setaddPadClass] = useState(false);
  const [showImmidiateSection, setimmidiateSection] = useState(false);
  const [open, setOpen] = useState(false);
  const [hsnCategories, setHsnCategories] = useState([]);
  const [hsnAllCategories, setHsnAllCategories] = useState([]);
  const [hsnSubCategories, setSubHsnCategories] = useState([]);
  const [hsnAllSubCategories, setAllSubHsnCategories] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [APIData, setAPIData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const router = useRouter();
  const [show, setShow] = useState(false);
  const [showHsn, setShowHsn] = useState(false);
  const [showMainDropdown, setShowMainDropdown] = useState(true);
  const [showSearchDropdown, setshowSearchDropdown] = useState(true);
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const [accordionHSNOpen, setAccordionHSNOpen] = useState(false);
  const [selectedDesc, setSelectedDesc] = useState("HSN");
  const [open1, setOpen1] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const searchDropDownRef = useRef(null);
  const subCategoryDropDownRef = useRef(null);
  const [isLoadingAllCategories, setIsLoadingAllCategories] = useState(false);
  const [isLoadingSubCategories, setIsLoadingSubCategories] = useState(false);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [noDataFoundinSearch, setnoDataFoundinSearch] = useState(false);
   const [showhsnDetail, setshowhsnDetail] = useState(false);
   useEffect(
    () => {
      const handleEsc = (event) => {
        if (event.keyCode === 27) {
          setshowSearchDropdown(false);
        }
      };

      window.addEventListener("keydown", handleEsc);
      function handleClickOutside(event) {
        if (
          searchDropDownRef.current &&
          !searchDropDownRef.current.contains(event.target)
        ) {
          setshowSearchDropdown(false);
        }

        if (
          subCategoryDropDownRef.current &&
          !subCategoryDropDownRef.current.contains(event.target)
        ) {
          setShowSubDropdown(false);
        }
      }
      // Bind the event listener

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("keydown", handleEsc);
      };
    },
    [searchDropDownRef],
    [subCategoryDropDownRef]
  );
  
   useEffect(() => {
    if (searchTerm.length >= 3) {
      fetchData(searchTerm);
      setnoDataFoundinSearch(false)
    }
  }, [searchTerm]);

  const showAllButtonClick = () => {
    setcrad3Section(false);
    setSeeAllSection(true);
    setFAQSection(false);
    setCounterSection(false);
    setimmidiateSection(true);
    setremovePadClass(false);
    setaddPadClass(true);
    setshowhsnDetail(false);
    setShowSubDropdown(false);
    getAllCategories();
  };

  const fetchData = async () => {

    setshowSearchDropdown(true);
    setIsLoadingSearch(true)
  
    const body = {
      searchTerm: searchTerm,
    };

    let config = {
      method: "post",
      url: ENDPOINTS.HSN_SEARCH_KEYPRESS_API,
      headers: {
        "Content-Type": "application/json",
        // 'g-recaptcha-response':gReCaptchaToken
      },
      data: body,
    };
    try {
      setnoDataFoundinSearch(false)
      const response = await axios(config);
      if(filteredResults.length == 0){
        setIsLoadingSearch(false);
  
        }
      setAPIData(response.data);
      setSearchInput(searchTerm);
      setFilteredResults(response.data.result);
      setIsLoadingSearch(false);
    
      if(response.data.result.length != 0){
        setnoDataFoundinSearch(false)
      }else{
        setnoDataFoundinSearch(true)

      }
    } catch (err) {
    }
  };
  //function call on category hover end
  function showAllPhoneCategories() {
    setOpen1(true);
    getAllCategories();
  }
  //function call on category hover end

  //function all catetories dropdown start
  async function getCategories() {
    setIsLoadingAllCategories(true);
    setShowMainDropdown(true);
    setshowSearchDropdown(false);
    const body = {
      sort: {
        field: "sectionNum",
        order: "asc",
      },
      from: 0,
      size: 5,
    };
    let config = {
      method: "post",
      url: ENDPOINTS.HSN_CATEGORIES_API,
      data: body,
    };
    try {
      const response = await axios(config);
      if (hsnCategories.length == 0) {
        setIsLoadingAllCategories(false);
      }
      setHsnCategories(response.data.result);
      // setHsnAllCategories(response.data.result)
      setIsLoadingAllCategories(false);
    } catch (err) {
    }
  }

    const handleSubCategoryBox = () => {
      setShowSubDropdown(false);
    };

    const handleInputChange = (event) => {
      setSearchTerm(event.target.value);
    };

// Async function to fetch subcategories
const getSubCategory = useCallback(async (id, desc) => {
  setSelectedDesc(() => {
    if (desc.includes(",")) {
      return desc.substring(0, desc.indexOf(","));
    } else if (desc.includes(";")) {
      return desc.substring(0, desc.indexOf(";"));
    } else {
      return desc;
    }
  });

  const body = {
    where: {
      "section.$id": {
        type: "search",
        value: id,
      },
    },
    sort: {
      field: "chapter_num",
      order: "asc",
    },
  };

  let config = {
    method: "post",
    url: ENDPOINTS.HSN_SUBCATEGORIES_API,
    data: body,
  };
  try {
    const response = await axios(config);
    if (hsnSubCategories.length === 0) {
      setIsLoadingSubCategories(false);
    }
    setSubHsnCategories(response.data.result);
    setIsLoadingSubCategories(false);
  } catch (err) {
    setIsLoadingSubCategories(false);
  }
}, [hsnSubCategories]);

// Debounced version of the async getSubCategory function
const debouncedGetSubCategory = useCallback(debounce(getSubCategory, 500), [getSubCategory]);

const handleMouseEnter = (id, desc) => {
  debouncedGetSubCategory(id, desc);
  setIsLoadingSubCategories(true);
  setShowSubDropdown(true);
};

const handleMouseLeave = () => {
  debouncedGetSubCategory.cancel();
  setShowSubDropdown(false)
  setIsLoadingSubCategories(false);
};

  function scrollToEnd () {
    const section = document.getElementById('mySection');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth',block: "start" });
      }
  };

    const handleOnCloseHsn = () => {
      setShowHsn(false);
    };

  async function getAllCategories() {
    scrollToEnd() 
    const body = {
      sort: {
        field: "sectionNum",
        order: "asc",
      },
      from: 0,
      size: 24,
    };
    let config = {
      method: "post",
      url: ENDPOINTS.HSN_CATEGORIES_API,
      data: body,
    };
    try {
      const response = await axios(config);
      setHsnAllCategories(response.data.result);
    } catch (err) {
    }
  }
  //function on seel all categories in dropdown

  const accordionHSNToggle = (index, id, desc) => {
    setSelectedDesc(desc);
    if (accordionHSNOpen === index) {
      return setAccordionHSNOpen(null);
    }
    setAccordionHSNOpen(index);
    getAllSubCategory(id);
  };
  async function getAllSubCategory(id) {
    const body = {
      where: {
        "section.$id": {
          type: "search",
          value: id,
        },
      },
      sort: {
        field: "chapter_num",
        order: "asc",
      },
    };
    let config = {
      method: "post",
      url: ENDPOINTS.HSN_SUBCATEGORIES_API,
      data: body,
    };
    try {
      const response = await axios(config);

      setAllSubHsnCategories(response.data.result);
    } catch (err) {
      console.log("err", err);
    }
  }

  function highlightText(text, highlight) {
    // Escaping special characters in the search input
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="bg-yellow-300 font-bold">{part}</span>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  }

 const handleEventsCheck = (url) =>{
    pushCleverTapEvent("HSN_Code_Search", { 'PageName': 'HSN_Page','HSNCode': url, 'userProperties': 'last_hsn_searched_category'});
 }
  
    return (
    <div className={router.pathname === '/hsn-code' ? '' : "sm:pt-[100px] pt-[77px]"}>
       {/* /* hsn finder input start */}
  
        <section 
             className={[
              'relative sm:z-[10] ',
              router.pathname == "/hsn-code" ? ' py-12 md:py-6 sm:pb-6 sm:pt-16' : 'pb-[60px] pt-[80px] sm:pb-5 sm:pt-12',
            ].join(' ')}
        >
          <Image
          priority
          src={IMAGES.ImportFactoring.ImportBGBanner.src}
          width={1366}
          height={550}
          className="absolute inset-0 max-w-none w-full h-full -z-[1]"
          alt="Banner Desktop"
        />
        <div className="max-w-[1100px] mx-auto xm:px-2 sm:px-2">
        {router.pathname == "/hsn-code" ?<>
            <h1 className="font-medium text-center mb-1">
              <span className="block text-xxl sm:text-lg text-[#FFFFFF] sm:mb-xsp">
              HSN Code Finder
              </span>
              <span className="block text-headingbold sm:mb-xsp font-medium sm:text-xxl text-[#FFFFFF] md:text-heading5">
              Search HSN or SAC Codes for GST Rates
              </span>
            </h1>
            <p className="text-base sm:text-sm text-[#FFFFFF] mb-3 sm:mb-3 md:text-lg text-center">
            Know the correct HSN Code and latest GST Rates for your product or service. Search by either product name or HSN Code.
            </p> 
              </>: <>
            <p className="block text-xxl sm:text-lg text-[#FFFFFF] sm:mb-xsp text-center">
              Find HSN or ITC HS code
            </p>
            <p className="block text-headingbig mb-3 sm:mb-xsp font-medium sm:text-2xl text-[#FFFFFF] md:text-heading5 text-center">
              By product name or HSN code
            </p> </>}
            <div className="sm:w-full w-[800px] md:w-full m-auto relative">
              <div className="flex items-start justify-between md:justify-center relative z-[51]">
                <div className="sm:w-[15%] md:w-[10%]">
                  <Menu as="div" className="inline-block text-left">
                    <div>
                      <Menu.Button
                        onClick={getCategories}
                        className="inline-flex md:hidden sm:hidden sm:w-full w-[177px] justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50"
                      >
                        <span>All Categories</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"></path></svg>
                      </Menu.Button>
                      <div className="hidden sm:block md:block justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp md:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 sm:h-[50px] sm:w-[100%]">
                        <div className="flex items-center">
                          <span className="sr-only">Open main menu</span>
                          <svg 
                           onClick={showAllPhoneCategories}
                           xmlns="http://www.w3.org/2000/svg" 
                           viewBox="0 0 24 24" 
                           width="36" 
                           height="36" 
                           fill="currentColor" 
                           className="block h-6 w-6 sm:w-full sm:h-6"
                           aria-hidden="true">
                           <path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path>
                         </svg>
                        </div>
                      </div>
                    </div>
                    <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
                      <Transition.Root show={open1} as={Fragment}>
                        <Dialog
                          as="div"
                          className="relative z-[100]"
                          onClose={setOpen}
                        >
                          <div className="fixed inset-0" />

                          <div className="fixed inset-0 overflow-hidden">
                            <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-14">
                                <Transition.Child
                                  as={Fragment}
                                  enter="transform transition origin-left ease-in-out duration-300 sm:duration-300"
                                  enterFrom="translate-x-full"
                                  enterTo="translate-x-0"
                                  leave="transform transition ease-in-out duration-300 sm:duration-300"
                                  leaveFrom="translate-x-0"
                                  leaveTo="translate-x-full"
                                >
                                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white">
                                      <button
                                        type="button"
                                        className="rounded-md left-[-45px] sm:left-1 top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2"
                                        onClick={() => setOpen1(false)}
                                      >
                                        <span className="sr-only">
                                          Close panel
                                        </span>
                                        <XMarkIcon
                                          className="h-6 w-6 text-white"
                                          aria-hidden="true"
                                        />
                                      </button>
                                      <div className="relative px-0">
                                        <div className="sm:pt-3">
                                          <div className="mt-3 text-center sm:mt-0">
                                            <section className="bg-white">
                                              <div className="container px-3 xm:px-2">
                                                <div className="bg-white sm:w-auto text-left  lg:m-auto">
                                                  <div className="mx-auto  sm:w-auto">
                                                    {hsnAllCategories?.map(
                                                      (data, index) => {
                                                        return (
                                                          <div className="border border-bordercolor overflow-hidden rounded-lg mb-2">
                                                            <div
                                                              className="bg-[#EFF5FA] p-2 flex justify-between items-center cursor-pointer "
                                                              onClick={() =>
                                                                accordionHSNToggle(
                                                                  index,
                                                                  data.id,
                                                                  data.description
                                                                )
                                                              }
                                                            >
                                                              <p className="text-base text-secondary font-medium">
                                                                {data.description}
                                                              </p>
                                                              <div className="">
                                                                {index ===
                                                                accordionHSNOpen ? (
                                                                  <svg
                                                                    xmlns="https://www.w3.org/2000/svg"
                                                                    viewBox="0 0 24 24"
                                                                    width="24"
                                                                    height="24"
                                                                  >
                                                                    <path d="M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z"></path>
                                                                  </svg>
                                                                ) : (
                                                                  <svg
                                                                    xmlns="https://www.w3.org/2000/svg"
                                                                    viewBox="0 0 24 24"
                                                                    width="24"
                                                                    height="24"
                                                                  >
                                                                    <path d="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z"></path>
                                                                  </svg>
                                                                )}
                                                              </div>
                                                            </div>
                                                            <Collapse
                                                              isOpened={
                                                                index ===
                                                                accordionHSNOpen
                                                              }
                                                            >
                                                              {hsnAllSubCategories.map(
                                                                (data1) => {
                                                                  const chapterLink = WEB_URL + `/hsn-code/chapter/${data1.chapter}`;
                                                                  return (
                                                                    <Link href={WEB_URL+`/hsn-code/chapter/${data1.chapter}`} rel="noopener noreferrer"> 
                                                                    <div
                                                                      className="bg-white text-base text-[#4B93EE] p-1 cursor-pointer"
                                                                      onClick={() => {
                                                                        pushCleverTapEvent("HSN_Category", { "PageName": 'HSN_Page',"HSNCode": data1.chapter});
                                                                        setOpen1(false);
                                                                      }}
                                                                      key={index}
                                                                    >
                                                                      <div className="flex">
                                                                        <span className="mr-2">
                                                                          {" "}
                                                                          {
                                                                            data1.chapter
                                                                          }
                                                                        </span>{" "}
                                                                        <span>
                                                                          {" "}
                                                                          {
                                                                            data1.description
                                                                          }{" "}
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                    </Link>
                                                                  );
                                                                }
                                                              )}
                                                            </Collapse>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </section>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Dialog.Panel>
                                </Transition.Child>
                              </div>
                            </div>
                          </div>
                        </Dialog>
                      </Transition.Root>
                    </HideCategoryMenuContext.Provider>
                    {showMainDropdown && (
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items
                          className={`absolute pointer-events-auto left-[0px] z-10 mt-2 w-[223px] min-h-[320px] origin-top-right  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                            showSubDropdown ? "rounded-s-lg" : "rounded-md"
                          }`}
                        >
                          <>
                            <div className="py-1">
                              <Menu.Item>
                                <ul>
                                  {isLoadingAllCategories && (
                                    <li className="text-brand font-medium flex justify-center">
                                 <LineWave height="100" width="100" color="#022b5c" middleLineColor="#e3a200" lastLineColor="#022b5c" />
                                    </li>
                                  )}
                                  {hsnCategories.map((item) => (
                                    <li
                                      key={item.id}
                                      aria-expanded={
                                        showSubDropdown ? "true" : "false"
                                      }
                                      // onMouseOver={() =>
                                      //   getSubCategory(
                                      //     item.id,
                                      //     item.description
                                      //   )
                                      // }

                                      onMouseOver={() => handleMouseEnter(item.id,item.description)} 
                                      onMouseOut={handleMouseLeave}
                                      
                                      onClick={() => setShowSubDropdown(false)}
                                      className="text-brand font-medium cursor-pointer"
                                    >
                                      <div className="relative">
                                        <div className="flex items-center relative justify-between text-sm p-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA] ">
                                          <span className="inline-block max-w-[80%]">
                                            {" "}
                                            {
                                              item.description
                                            }{" "}
                                          </span>
                                          <svg
                                            xmlns="https://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                            className="w-[15px] h-[15px]"
                                          >
                                            <path
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                  <li
                                    className="text-brand font-medium"
                                    onClick={showAllButtonClick}
                                  >
                                    <div className="relative" onClick={() => setOpen1(true)}>
                                      <div className="flex items-center relative justify-between text-sm p-1 my-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]  cursor-pointer">
                                        Show all
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </Menu.Item>
                            </div>
                          </>
                        </Menu.Items>
                      </Transition>
                    )}
                  </Menu>
                  <div
                    onMouseOver={() => setShowSubDropdown(true)}
                    className={`absolute top-[55px]  left-[213px] z-10  h-[320px] min-h-[320px]  w-[595px] max-w-[595px] transform px-1 sm:px-0 ${
                      showSubDropdown ? "block" : "hidden"
                    }`}
                  >
                    <div
                      ref={subCategoryDropDownRef}
                      className="overflow-hidden h-full shadow-lg ring-1 ring-black ring-opacity-5"
                      onClick={handleSubCategoryBox}
                    >
                      <div className="relative grid bg-white py-1 h-full">
                        <ul className="overflow-auto h-full">
                        {isLoadingSubCategories && (
                          <li className="flex cursor-pointer justify-center text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                          <LineWave height="100" width="100" color="#022b5c" middleLineColor="#e3a200" lastLineColor="#022b5c" />
                          </li>
                          )}

                          {!isLoadingSubCategories && (
                          <>
                            {hsnSubCategories.map((item) => (
                              <Link key={item.id} href={WEB_URL+`/hsn-code/chapter/${item.chapter}`} rel="noopener noreferrer">  
                              <li
                                key={item.id}
                                
                                className="flex cursor-pointer text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]"
                                onClick={() => {
                                  pushCleverTapEvent("HSN_Category", { "HSNCode": `${item.chapter}`});
                                }}
                              >
                                <span className="text-anchor-blue mr-2">
                                  {item.chapter}
                                </span>{" "}
                                {item.description}
                              </li>
                              </Link>  
                            ))}
                          </>)}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sm:w-[84%] w-[85%] sm:ml-[1%] ml-[20px]">
                  <div className="relative flex items-start">
                    <input
                      value={searchTerm}
                      onChange={handleInputChange}
                      type="text"
                      name="search"
                      id="search"
                      autoComplete="off"
                      placeholder="Enter HSN Code or product description"
                      className="inline-flex w-[606px] sm:w-full tex-sm sm:h-[50px] md:h-[50px] md:w-[100%]  md:ml-0 lg:justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none"
                    />

                    <div className="absolute inset-y-0 right-0 flex py-1.5 pr-1.5 bg-white rounded-r-[10px] mt-0.5">
                      <div className="inline-flex items-center px-1 font-sans text-xs text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="currentColor"
                        >
                          <path d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div className="text-center mt-3 flex flex-wrap justify-center">
                <span className="text-white sm:mb-1 sm:text-sm mr-2">Frequently Searched:</span> 
                <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search/furniture`}>Furniture</Link>
                <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search/cement`}>Cement</Link>
                <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search/sugar`}>Sugar</Link>
                <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search/battery`}>Battery</Link>
                <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search/rice`}>Rice</Link>
                {router.asPath !== '/hsn-code/search' && <Link className="text-white sm:mb-1 sm:text-sm mx-1 hover:underline" href={WEB_URL+`/hsn-code/search`}>View All</Link>}
              </div>

              {showSearchDropdown && (
                <>
                  {searchInput.length >= 2 ? (
                    <div
                      ref={searchDropDownRef}
                      className="bg-white drop-shadow z-[50] absolute lg:top-[15px] max-h-[325px] overflow-auto searchDrodownMobileLeft lg:pt-[32px] lg:ml-[197px] lg:w-[599px] tex-sm sm:h-auto md:w-[85%] sm:w-[80%] md:ml-0 sm:left-[20%] md:left-[15%]"
                    >
                        {noDataFoundinSearch && (
                      <li className="text-brand font-medium flex justify-center">
                       NO DATA FOUND
                      </li>
                       )}

                       {isLoadingSearch && (
                      <li className="text-brand font-medium flex justify-center">
                      <LineWave height="100" width="100" color="#022b5c" middleLineColor="#e3a200" lastLineColor="#022b5c" />
                      </li>
                       )}
                      {filteredResults.map((result, index) => {
                       return(
                        <>
                        {/* {result.description.filter(searchInput) ? ( */}
                          <Link href={WEB_URL+`/hsn-code/${result.hsn}`}>
                        <div
                          onClick={() =>{
                            setshowSearchDropdown(false);
                            handleEventsCheck(`${result.hsn}`);
                          }}
                          className="w-full cursor-pointer p-1 flex border-b border-[#00000020]"
                          key={index}
                        >
                          <span className="mr-2 text-[12px] h-[20px] text-white w-[25px] font-medium rounded-sm bg-[#022b5c] p-[3px] flex items-center justify-center">
                            {" "}
                            {result.chapter}{" "}
                          </span>
                          {/* <span className="pr-2 text-[14px]">
                            {" "}
                            {textCapitalized(result.descriptionString)}
                            {result.hsn != null && (
                              <span> ({result.hsn} )</span>
                            )}
                          </span> */}

                          <span className="pr-2 text-[14px]">
                            {highlightText(result.descriptionString, searchInput)}
                            {result.hsn != null && (
                              <span> ({highlightText(result.hsn, searchInput)})</span>
                            )}
                          </span>
                        </div>
                        </Link>
                        {/* ) 
                    : (
                      <p>No Data Found.</p>
                    )} */}
                      </>
                       )
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        </section>

        <HsnPopup
          onClose={handleOnCloseHsn}
          show={showHsn}
          setShowHsn={(bool) => setShow(bool)}
        />
     
      {/* /* hsn finder input end */}
      <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
            <div className="fixed inset-0" />
            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                <div className=" fixed inset-y-0 right-0 flex max-w-full pl-14">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-500"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                      <div className="flex h-full flex-col overflow-y-scroll bg-white pt-2 pb-6 shadow-xl">
                        <button
                          type="button"
                          className="rounded-md left-[-40px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon
                            className="h-6 w-6 text-white"
                            aria-hidden="true"
                          />
                        </button>
                        <div className="relative px-0">
                          {/* Replace with your content */}
                          <Categorymenu open={open} />
                          {/* /End replace */}
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </HideCategoryMenuContext.Provider>
      <HsnPopup
        onClose={handleOnCloseHsn}
        show={showHsn}
        setShowHsn={(bool) => setShow(bool)}
      />
    </div>
  );
}

// Debounce function definition for async functions
function debounce(func, delay) {
  let timeoutId;
  const debouncedFunction = function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };

  // Method to cancel the debounce
  debouncedFunction.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  return debouncedFunction;
}

export const HideCategoryMenuContext = createContext();
